var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8996 12.0016C21.8996 17.4692 17.4672 21.9016 11.9996 21.9016M21.8996 12.0016C21.8996 6.53394 17.4672 2.10156 11.9996 2.10156M21.8996 12.0016H2.09961M11.9996 21.9016C6.53199 21.9016 2.09961 17.4692 2.09961 12.0016M11.9996 21.9016C14.1535 21.9016 15.8996 17.4692 15.8996 12.0016C15.8996 6.53394 14.1535 2.10156 11.9996 2.10156M11.9996 21.9016C9.8457 21.9016 8.09961 17.4692 8.09961 12.0016C8.09961 6.53394 9.8457 2.10156 11.9996 2.10156M2.09961 12.0016C2.09961 6.53394 6.53199 2.10156 11.9996 2.10156",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeWhite);
export default __webpack_public_path__ + "static/media/globe-white.88fdee75cd59fc2a269e0cb7e3af8aa4.svg";
export { ForwardRef as ReactComponent };